import React from 'react';
import { Link } from 'react-router-dom';

function DeleteAccount() {
    return (
        <>
            <section className='landing_page_main'>
                <section className='cms_page_top_section'>
                    <div className='page_title_section'>
                        <h1>Delete Your BYP Account</h1>
                        <div className='breadcrumb_section'>
                            <ul className="breadcrumb">
                                <li><Link to="/">Home</Link></li>
                                <li> Delete Account</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className='cms_content_section list_li_bold'>
                    <div className='container'>
                        <p>You can permanently delete your BYP account and associated personal budgeting data directly from the BYP mobile app.</p>

                        <div className='mt-70'>
                            <h3>How to delete your account</h3>
                            <ol className='list_about'>
                                <li>Open BYP and sign in to your account.</li>
                                <li>Open Settings.</li>
                                <li>Select <strong>Delete Account</strong>.</li>
                                <li>Review the confirmation message and confirm deletion.</li>
                            </ol>
                        </div>

                        <div className='mt-70'>
                            <h3>What is deleted</h3>
                            <p>When your account is deleted, BYP removes or de-identifies personal account information and deletes associated budgeting information, including applicable income, savings, expenses, planned expenses, allowance information, paycheck-planning data, notification-related account information, and other data associated with your budgeting profile.</p>
                            <p>Authentication information and device-related account identifiers are also removed or invalidated.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>Information that may be retained</h3>
                            <p>Certain limited subscription transaction records may be retained when reasonably necessary for payment records, accounting, audit, fraud prevention, legal compliance, or dispute-resolution purposes.</p>
                            <p>Retained records are not used to restore a deleted user's personal budgeting profile.</p>
                        </div>

                        <div className='mt-70'>
                            <h3>Need assistance?</h3>
                            <p>If you cannot access the app or need help with account deletion, contact us at <a href="mailto:info@bypapp.com">info@bypapp.com</a>.</p>
                        </div>
                    </div>
                </section>
            </section>
        </>
    );
}

export default DeleteAccount;
